import { render } from "./DrawerContent.vue?vue&type=template&id=d22c92b0&ts=true"
import script from "./DrawerContent.ts?vue&type=script&lang=ts"
export * from "./DrawerContent.ts?vue&type=script&lang=ts"

import "./DrawerContent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__